type LinkBeneficialOwner = (args: {
  variables: { entityId: number; childProfileId: number; percentage: number };
}) => Promise<unknown>;

type LinkControllingPerson = (args: {
  variables: { entityId: number; childProfileId: number; title?: string | null };
}) => Promise<unknown>;

type LinkRolesArgs = {
  parentProfileId: number;
  childProfileId: number;
  isOwner: boolean;
  isController: boolean;
  ownershipPercentage: number;
  title?: string;
  linkBeneficialOwner: LinkBeneficialOwner;
  linkControllingPerson: LinkControllingPerson;
};

/**
 * After creating a child profile, attach Owner / Controller edges via the
 * dedicated link mutations (title lives on the controller relationship).
 */
export const linkOwnerControllerRoles = async ({
  parentProfileId,
  childProfileId,
  isOwner,
  isController,
  ownershipPercentage,
  title,
  linkBeneficialOwner,
  linkControllingPerson,
}: LinkRolesArgs): Promise<void> => {
  if (isOwner) {
    await linkBeneficialOwner({
      variables: {
        entityId: parentProfileId,
        childProfileId,
        percentage: ownershipPercentage,
      },
    });
  }

  if (isController) {
    await linkControllingPerson({
      variables: {
        entityId: parentProfileId,
        childProfileId,
        title: title || null,
      },
    });
  }
};
